const Popup = (url, cb) => {
  window.oauthCallback = (data) => {
    cb(data)
    window.oauthCallback = null
  }
  window.open(url, 'oauth', 'width=400,height=800,titlebar=no,status=no')
}

export { Popup }
